export const getRangeMidpoint = (rangeMin, rangeMax) => {
  const min = Number(rangeMin);
  const max = Number(rangeMax);

  return Number.isFinite(min) && Number.isFinite(max)
    ? min + ((max - min) / 2)
    : null;
};

export const getGradientLegendDisplayValues = (legend) => {
  const safeLegend = legend || {};

  return {
    minValue: safeLegend.actualMin ?? safeLegend.legendMin,
    midValue: getRangeMidpoint(safeLegend.legendMin, safeLegend.legendMax),
    maxValue: safeLegend.actualMax ?? safeLegend.legendMax,
  };
};
